module.exports = "/_next/static/images/AggregationAudienceCreation@2x-d2faca2c226f4aa6d4207870ea22a46a.webp";